(() => {
  function init(root) {
    if (!root || root.dataset.referenceReady) return;
    root.dataset.referenceReady = 'true';
    const details = [...root.querySelectorAll('[data-benefit]')];
    const images = [...root.querySelectorAll('[data-benefit-image]')];
    details.forEach(detail => detail.addEventListener('toggle', () => {
      if (!detail.open) return;
      details.forEach(other => { if (other !== detail) other.open = false; });
      images.forEach(image => { image.hidden = image.dataset.benefitImage !== detail.dataset.benefit; });
    }));
    const track = root.querySelector('[data-stories]');
    if (!track) return;
    const slides = [...track.children];
    const previous = root.querySelector('[data-story-prev]');
    const next = root.querySelector('[data-story-next]');
    const status = root.querySelector('.rc-story-status');
    let index = 0;
    const update = () => {
      const start = track.getBoundingClientRect().left;
      index = slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - start) < Math.abs(slides[best].getBoundingClientRect().left - start) ? i : best, 0);
      status.textContent = `${index + 1} / ${slides.length}`;
      if (track.dataset.compact === 'true') track.style.height = `${slides[index].offsetHeight}px`;
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
    };
    const go = direction => {
      const target = Math.max(0, Math.min(slides.length - 1, index + direction));
      track.scrollTo({ left: slides[target].offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    previous.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); go(event.key === 'ArrowRight' ? 1 : -1); }
    });
    track.addEventListener('scroll', update, { passive: true });
    update();
    if ('ResizeObserver' in window) {
      let width = track.clientWidth;
      const observer = new ResizeObserver(() => { if (track.clientWidth !== width) { width = track.clientWidth; update(); } });
      observer.observe(track);
      root.rcReferenceCleanup = () => observer.disconnect();
    }
    root.rcSelectStory = blockId => {
      const selected = slides.find(slide => slide.dataset.storyBlock === blockId);
      if (selected) track.scrollTo({ left: selected.offsetLeft - slides[0].offsetLeft, behavior: 'instant' });
    };
  }
  document.querySelectorAll('[data-rc-reference]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rc-reference]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-rc-reference]').forEach(root => root.rcReferenceCleanup?.()));
  document.addEventListener('shopify:block:select', event => {
    const section = document.getElementById('shopify-section-' + event.detail?.sectionId);
    const root = section?.querySelector('[data-rc-reference]');
    if (!root) return;
    root.rcSelectStory?.(event.detail.blockId);
    const benefit = root.querySelector('[data-benefit="' + CSS.escape(event.detail.blockId) + '"]');
    if (benefit) benefit.open = true;
  });
})();
